import { render, staticRenderFns } from "./FilePickerMultiple.vue?vue&type=template&id=bfd5fdf6"
import script from "./FilePickerMultiple.vue?vue&type=script&lang=js"
export * from "./FilePickerMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports